import React from 'react';

const PokemonList = (props) => {
	const defaultText = props.list.length ? null : (props.default ? props.default : "All Pokemon");
	return (
		<div className='PokemonList'>
			{defaultText}
			{props.list.map(pokemon => (
				<div key={pokemon.value} className='PokemonListIcon' onClick={() => props.onClick(pokemon)}>
					<img src={'https://www.a2pogo.com/images/pokemon/icons-4/' + pokemon.value + '.png'} title={pokemon.label} alt={pokemon.label} />
				</div>
			))}
		</div>
	);
};

export default PokemonList;